export const tr = {
    cancel: 'İptal',
    dayBudgetLimit: 'Bütçe kısıtlaması',
    set: 'Kur',
    walletDayBudgetIsSet:
        'Ortak hesap için "{mode}" gösterim modu ve {sum} {currency} günlük bütçe kısıtlaması belirtildi. Kampanyanın günlük bütçesini kısıtlamak için daha küçük bir değer girin.'
};
